export default "__VITE_ASSET__IZ8o7MAd__"